// Class: haxe.xml._Fast.HasAttribAccess

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../hxClasses_stub").default;
var $import = require("./../../../import_stub").default;
function Xml() {return require("./../../../Xml");}
function js__$Boot_HaxeError() {return require("./../../../js/_Boot/HaxeError");}

// Constructor

var HasAttribAccess = function(x) {
	this.__x = x;
}

// Meta

HasAttribAccess.__name__ = ["haxe","xml","_Fast","HasAttribAccess"];
HasAttribAccess.prototype = {
	resolve: function(name) {
		if(this.__x.nodeType == (Xml().default).Document) {
			throw new (js__$Boot_HaxeError().default)("Cannot access document attribute " + name);
		}
		return this.__x.exists(name);
	}
};
HasAttribAccess.prototype.__class__ = HasAttribAccess.prototype.constructor = $hxClasses["haxe.xml._Fast.HasAttribAccess"] = HasAttribAccess;

// Init



// Statics




// Export

exports.default = HasAttribAccess;


//////////////////
// WEBPACK FOOTER
// ./lib/_gen/haxe/xml/_Fast/HasAttribAccess.js
// module id = 313
// module chunks = 0